<h1 class="h1">{{ translations.pageTitle }}</h1>
<vue-server-messages [messages]="messages"></vue-server-messages>

<app-retrieve-user
  [clientCode]="clientCode"
  [user]="user"
  [retrievalType]="retrievalType.PASSWORD"
  [nextAction]="viewPasswordResetOptions"
  [previousAction]="returnToLogin"
  [messages]="messages"
></app-retrieve-user>
